import React from 'react'

function PNGFileIcon() {
  return (
    <svg
      width='50'
      height='65'
      viewBox='0 0 50 65'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 8V14.5V57C0 61.4183 3.58172 65 8 65H42C46.4183 65 50 61.4183 50 57V14L36 0H8C3.58172 0 0 3.58172 0 8Z'
        fill='#E9E9E0'
      />
      <path
        d='M0 45H50V57C50 61.4183 46.4183 65 42 65H8C3.58172 65 0 61.4183 0 57V45Z'
        fill='#659C35'
      />
      <path
        d='M36.0465 0.175781V13.9537H49.8244L36.0465 0.175781Z'
        fill='#D9D7CA'
      />
      <path
        d='M14.4547 22.0924C17.3888 22.0924 19.7674 19.7138 19.7674 16.7796C19.7674 13.8454 17.3888 11.4668 14.4547 11.4668C11.5205 11.4668 9.14186 13.8454 9.14186 16.7796C9.14186 19.7138 11.5205 22.0924 14.4547 22.0924Z'
        fill='#F3D55B'
      />
      <path
        d='M0 45.3489H12.7907H50V32.5582L38.3721 21.5117L26.1628 34.8838L19.7872 28.5082L0 45.3489Z'
        fill='#88C057'
      />
      <path
        d='M11.9082 61.3941H10V49.9121H13.3698C13.8675 49.9121 14.3605 49.9896 14.8477 50.1457C15.3349 50.3018 15.7721 50.5354 16.1593 50.8465C16.5465 51.1576 16.8593 51.5348 17.0977 51.9758C17.3361 52.4168 17.4558 52.9125 17.4558 53.464C17.4558 54.0463 17.3547 54.5728 17.1535 55.0457C16.9523 55.5186 16.6709 55.9163 16.3105 56.2377C15.95 56.559 15.5151 56.8086 15.007 56.9852C14.4989 57.1618 13.9361 57.2496 13.3221 57.2496H11.907L11.9082 61.3941ZM11.9082 51.3297V55.8787H13.657C13.8895 55.8787 14.1198 55.84 14.3489 55.7613C14.5768 55.6839 14.7861 55.5562 14.9768 55.3796C15.1675 55.203 15.3209 54.9568 15.4372 54.64C15.5535 54.3233 15.6116 53.9312 15.6116 53.464C15.6116 53.2772 15.5849 53.0606 15.5326 52.8179C15.4791 52.5741 15.3709 52.3405 15.207 52.1171C15.0419 51.8938 14.8116 51.7069 14.5151 51.5565C14.2186 51.406 13.8256 51.3308 13.3384 51.3308L11.9082 51.3297Z'
        fill='white'
      />
      <path
        d='M28.107 49.9121V61.3941H26.1675L21.5733 53.48V61.3941H19.6337V49.9121H21.5733L26.1675 57.8262V49.9121H28.107Z'
        fill='white'
      />
      <path
        d='M39.5535 55.4755V59.9151C39.3093 60.2171 39.0372 60.4621 38.7349 60.6547C38.4326 60.8473 38.1151 61.0057 37.7814 61.1299C37.4477 61.2541 37.1023 61.343 36.7477 61.3954C36.3919 61.4478 36.0407 61.4729 35.6907 61.4729C34.9907 61.4729 34.3477 61.3487 33.7593 61.0991C33.1709 60.8496 32.657 60.4815 32.2175 59.9926C31.7779 59.5038 31.4326 58.8918 31.1837 58.1546C30.9349 57.4173 30.8105 56.5649 30.8105 55.5997C30.8105 54.6345 30.9349 53.7844 31.1837 53.0529C31.4326 52.3201 31.7768 51.7105 32.2175 51.2228C32.657 50.7339 33.1733 50.3636 33.7675 50.1083C34.3605 49.8531 35.0023 49.7266 35.6907 49.7266C36.3268 49.7266 36.9198 49.8303 37.4709 50.0377C38.0221 50.2462 38.514 50.5573 38.9489 50.9721L37.6291 52.1253C37.3744 51.8233 37.0826 51.6057 36.7547 51.4712C36.4256 51.3367 36.0872 51.2684 35.7372 51.2684C35.3454 51.2684 34.9709 51.3401 34.6163 51.486C34.2605 51.6319 33.943 51.878 33.6628 52.2256C33.3814 52.5743 33.1616 53.0221 33.0035 53.5736C32.8454 54.1252 32.7593 54.7986 32.7489 55.5986C32.7593 56.378 32.8419 57.0526 32.9954 57.6235C33.1489 58.1944 33.3605 58.6617 33.6314 59.0252C33.9023 59.3887 34.2093 59.6588 34.5535 59.8354C34.8977 60.012 35.2605 60.0997 35.643 60.0997C35.7593 60.0997 35.9151 60.0918 36.1116 60.0758C36.307 60.0599 36.5035 60.0348 36.7 59.9983C36.8954 59.9619 37.0837 59.9129 37.264 59.8502C37.4442 59.7875 37.5768 59.6998 37.6616 59.5858V56.7507H35.6744V55.4732H39.5535V55.4755Z'
        fill='white'
      />
    </svg>
  )
}

export default PNGFileIcon
